import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DailyOperationReportDrawer from "./modules/DailyOperationReportDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import moment from 'moment';
import { getAction, postAction, downloadFile } from '@/api/manage';
import { querySiteTree, queryUserTreeList } from "../../../api/api";
export default {
  name: 'DailyOperationReportList',
  mixins: [JeecgListMixin],
  components: {
    DailyOperationReportDrawer: DailyOperationReportDrawer
  },
  data: function data() {
    return {
      pagePath: '/inspection/report/generate',
      pageTitle: '运维报告',
      autoLoadInit: false,
      showAddBtn: false,
      visible: false,
      userTree: [],
      // 人员信息
      tableArr: [],
      // 选择站点生成数据
      firmName: '',
      generationTime: '',
      siteTree: [],
      date: '',
      siteId: [],
      url: {
        delete: '/inspection/report/generate/delInspectionReportAndItem'
      },
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      siteColumn: {
        dataIndex: 'paramName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '维护人员',
        align: 'center',
        sorter: true
      },
      /*{
        dataIndex: 'deptId_departName',
        colName: 'dept_id',
        title: '所属部门',
        align: 'center'
      },*/
      {
        dataIndex: 'month',
        colName: 'month',
        title: '月份',
        align: 'center'
      }, {
        dataIndex: 'generationTime',
        title: '报告生成时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'remark',
        colName: 'remark',
        title: '备注',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  watch: {
    /*currentSiteId(value) {
      this.loadData(1)
    }*/
  },
  created: function created() {
    // 加载人员信息
    this.loadTreeList();
    this.loadData(1);
  },
  computed: {},
  methods: {
    moment: moment,
    searchQuery: function searchQuery() {
      this.loadData(1);
    },
    searchReset: function searchReset() {
      var param = JSON.parse(JSON.stringify(this.queryParam));
      this.queryParam = {};

      if (param.scopeId && param.siteId) {
        this.queryParam.scopeId = param.scopeId;
        this.queryParam.scope = param.scope;
        this.queryParam.siteId = param.siteId;
      } else if (param.scopeId) {
        this.queryParam.scopeId = param.scopeId;
        this.queryParam.scope = param.scope;
      } else if (param.siteId) {
        this.queryParam.siteId = param.siteId;
      }

      this.dates = {};
      this.searchResetImpl();
      this.loadData(1);
    },
    handleOk: function handleOk(value) {
      console.log('value', value); // setTimeout(() => {

      this.getGenerate(); // }, 1000)
    },
    handleCancel: function handleCancel() {
      this.visible = false;
    },
    getGenerate: function getGenerate() {
      var _this = this;

      var params = {};
      params.startTime = this.date.format('YYYY-MM');

      if (this.siteId.length > 0) {
        window.localStorage.setItem('selectedOprationSiteId', this.siteId);
        params.siteIds = this.siteId.join(',');
        this.visible = false;
      } else {
        this.$message.warning('请选择站点');
        return;
      }

      getAction('/inspection/report/record/generateBySiteIds', params).then(function (res) {
        if (res.success) {
          _this.tableArr = res.result; //this.onToEdit(res.result)

          _this.handleAdd(_this.tableArr);
        }
      });
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this2 = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this2.loading = false;
        }
      });
    },
    loadData: function loadData(arg) {
      this.initTableData(arg);
    },
    initTableData: function initTableData(arg) {
      var _this3 = this;

      //
      //if(!this.url.list){
      // this.$message.error("请设置url.list属性!")
      // return
      // }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.loading = true;
      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          _this3.dataSource = res.result.records;
          _this3.ipagination.total = res.result.total;
          _this3.loadNums++;
        } else {
          _this3.$message.warning('系统异常=>' + res.message);
        }

        _this3.loading = false;
      });
    },
    modalFormOk: function modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.loadData();
    },
    onDateTaskMonth: function onDateTaskMonth(value, dateArray) {
      this.queryParam.startTime = dateArray[0];
      this.queryParam.endTime = dateArray[1];
    },
    handleEdit: function handleEdit(record) {
      this.$refs.modalForm.edit(record); //console.log(record)

      this.$refs.modalForm.title = '编辑：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showMonth = true;
      this.$refs.modalForm.showDate = false;
    },
    onToAdd: function onToAdd() {
      this.visible = true;
      this.date = moment(new Date());

      if (window.localStorage.getItem('selectedOprationSiteId')) {
        console.log(window.localStorage.getItem('selectedOprationSiteId'));
        this.siteId = window.localStorage.getItem('selectedOprationSiteId').split(',');
      }

      this.getSite();
    },
    getSite: function getSite() {
      var _this4 = this;

      // 用户
      querySiteTree({
        addrType: 1
      }).then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];

            _this4.siteTree.push(temp);
          }
        }
      });
    },
    handleAdd: function handleAdd(tableArr) {
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showMonth = true;
      this.$refs.modalForm.showDate = true;
      this.$refs.modalForm.add(tableArr);
      this.$refs.modalForm.month = this.date;
    },
    handleDetail: function handleDetail(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = this.pageTitle + '详情';
      this.$refs.modalForm.disableSubmit = true;
      this.$refs.modalForm.showMonth = false;
      this.$refs.modalForm.showDate = false;
    },
    handleCopy: function handleCopy(record) {
      this.visible = true;
      this.firmName = '';
      this.$refs.modalForm.maxMonth = this.generationTime;
      this.$refs.modalForm.title = '复制：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.copy(record);
    },
    cancel: function cancel() {
      this.visible = false;
    }
  }
};